import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-up",
  "use": "arrow-up-usage",
  "viewBox": "0 0 20.3 27.4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20.3 27.4\" id=\"arrow-up\"><g fill=\"none\" stroke-width=\"3\" stroke-miterlimit=\"10\"><path d=\"M1.1 11.3l9.1-9.2 9.1 9.2M10.2 27.4V2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol